import React from "react";
import { t } from "i18next"; // Import t function for translation

const OrderDetailListItem = (props) => {
  const { item } = props || {};

  return (
    <div className="order-detail-list-item">
      <div className="order-detail-list-item-header d-flex justify-content-between align-items-center">
        <div className="order-detail-list-item-header-title">
          {t("orderDetailListItem.productNameTitle")}:
        </div>
        <div className="order-detail-list-item-header-price">
          {t("orderDetailListItem.quantityTitle")}: {item?.quantity}
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center">
        <div className="order-detail-list-item-name">{item?.productName}</div>
        <div className="order-detail-list-item-header-points">
          {t("orderDetailListItem.pointsTitle")}: {item?.points}
        </div>
      </div>
    </div>
  );
};

export default OrderDetailListItem;
